import React, { useCallback, useState } from "react";
import { Modal, Box, Typography, Tooltip, IconButton } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";

import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";
import Spinner from "../../component/loading-screen/Spinner";
import CancelIcon from "@mui/icons-material/Cancel";

const ApproveReject = ({ data, refresh, disabled }) => {
  const [updateLoading, setUpdateLoading] = useState(false);
  const [actionType, setActionType] = useState("");
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = (type) => {
    setActionType(type);
    setOpen(true);
  };

  const updateLeave = useCallback(() => {
    const apiEndpoint = ApiEndpoints.UPDATE_LEAVE;

    postJsonData(
      apiEndpoint,
      {
        id: data.id,
        status: actionType,
      },
      setUpdateLoading,
      (res) => {
        okSuccessToast(res.data.message);
        setUpdateLoading(false);
        setOpen(false);
        refresh();
      },
      (error) => {
        apiErrorToast(error);
        setUpdateLoading(false);
        setOpen(false);
      }
    );
  }, [actionType, data.id, refresh]);

  const handleSubmit = (e) => {
    e.preventDefault();
    updateLeave();
  };

  // Check if leave is already approved or rejected
  const isActionTaken = data.status === "APPROVED" || data.status === "REJECTED";

  return (
    <>
      {/* Only show buttons if no action has been taken yet */}
      {!isActionTaken && (
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Tooltip title="Approve Leave">
            <IconButton
              color="success"
              onClick={() => handleOpen("APPROVED")}
              disabled={disabled}
            >
              <CheckCircleIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Reject Leave">
            <IconButton
              sx={{ color: "rgb(228, 36, 36)" }}
              onClick={() => handleOpen("REJECTED")}
              disabled={disabled}
            >
              <CancelIcon />
            </IconButton>
          </Tooltip>
        </Box>
      )}

      {/* Show status text if action is already taken */}
      {isActionTaken && (
        <Typography variant="body2" color="textSecondary">
          {data.status}
        </Typography>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="leave-action-title"
        aria-describedby="leave-action-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Spinner loading={updateLoading} />

          <ModalHeader
            title={`${actionType} Leave`}
            handleClose={handleClose}
            subtitle={`Easily ${actionType.toLowerCase()} the leave`}
          />

          <Typography
            id="leave-action-description"
            variant="h6"
            fontWeight="bold"
            sx={{ mt: 2 }}
          >
            Are you sure you want to {actionType.toLowerCase()} this leave?
          </Typography>

          <Box mt={3}>
            <ModalFooter
              form="leave-action"
              request={updateLoading}
              btn={actionType}
              onClick={handleSubmit}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ApproveReject;
